import React from 'react';
import './Styles.css';
import OutsideClickHandler from '../OutsideClickHandler';

const MenuList = ({ children, isOpen, onOutsideClick }) => {
  return (
    <>
      {isOpen && (
        <OutsideClickHandler onOutsideClick={onOutsideClick}>
          <ul className="menu-list-container">{children}</ul>
        </OutsideClickHandler>
      )}
    </>
  );
};

export default MenuList;
